import queryString from 'query-string'

/**
 * Parses a query param value from an optional input url or the current browser url.
 *
 * @param {string} paramName Query parameter name
 * @param {string} url URL to parse from
 * @returns {string} Query parameter parameter value
 */
export function getQueryParam (paramName, url = window.location.search) {
  const queryParams = queryString.parse(url)
  return queryParams[paramName]
}

/**
 * Parses entire query param value from an optional input url or the current browser url.
 *
 * @param {string} url URL to parse from
 * @returns {string} Query parameter parameter value
 */

export function getAllQueryParam (url = window.location.search) {
  const queryParams = queryString.parse(url)
  return queryParams
}

/**
 * Clean the url parameters
 *
 * @param {string} url URL to parse from
 * @param {string} parameter parameter to remove from url
 * @returns {string} Cleaned url  value
 */

export function removeURLParameter (url = window.location.search, parameter) {
  // prefer to use l.search if you have a location/link object
  const urlparts = url.split('?')
  if (urlparts.length >= 2) {
    const prefix = encodeURIComponent(parameter) + '='
    const pars = urlparts[1].split(/[&;]/g)

    // reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0;) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
  }
  return url
}

export function parseUrl (url) {
  if (!url) {
    return
  }

  return queryString.parseUrl(url, { parseFragmentIdentifier: true })
}
